<template>
  <div class="columns users">
    <div class="column is-12">

      <h1 class="title"><i class="fa fa-users"></i> {{this.name}}: {{title}} </h1>
      <p v-for="key in Object.keys(data)" v-bind:key="key">
        <strong>{{key}}: </strong> {{data[key]}}
      </p>

    </div>
  </div>
</template>

<script>
import modelMixin from '../mixins/model'

export default {
  name: 'ModelView',
  mixins: [modelMixin],

  data () {
    return {
    }
  },
  computed: {
    data: function () {
      return this.models
    },
    title: function () {
      return this.data.title || this.data.name || ''
    }
  },
  methods: {
    log: function (item) {
      console.log(item)
    }
  }
}
</script>
